import { get, post, unwrapPage } from "./api_helper";
import moment from "moment";

// Outbox / sent-message history. GET /api/sms/campaigns → Page<CampaignSummaryDto>.
// Date filter on createdAt: from inclusive, to exclusive (picker `to` is an
// inclusive day, so push it to the next day's 00:00).
export const getBulkListData = ({ from, to, page = 0, pageSize = 20, includeSandbox = false } = {}) => {
  const params = new URLSearchParams({ page, size: pageSize, includeSandbox });
  if (from) params.set("from", moment(from).startOf("day").toISOString());
  if (to) params.set("to", moment(to).add(1, "day").startOf("day").toISOString());
  return get(`sms/campaigns?${params.toString()}`).then((res) => {
    const p = unwrapPage(res);
    const rows = p.rows.map((c) => ({
      id: c.batchId,
      shortcode: c.sender,
      message: c.message || "—",
      send_date_time: c.createdAt,
      send_count: c.totalRecipients,
      unit_consumed: c.unitsUsed ?? "",
      lists: Array.isArray(c.lists) ? c.lists : [],
      delivered_count: c.deliveredCount,
      failed_count: c.failedCount,
      pending_count: c.pendingCount,
      source: c.source,
    }));
    return { rows, total: p.total, totalPages: p.pages, page: p.page };
  });
};

// Message detail header. GET /api/sms/batch/{batchId}/summary → BatchSummaryDto.
export const getBulkScheduleDetail = (id) =>
  get(`sms/batch/${id}/summary`).then((b) => ({
    id: b.batchId,
    shortcode: b.sender,
    user: b.sender,
    contact_list: "",
    send_date_time: b.createdAt,
    message: b.message || "",
    send_count: b.totalMessages,
  }));

// Per-recipient delivery reports. GET /api/sms/batch/{batchId}/messages.
// status '0' = Delivered (the legacy convention the page checks).
export const getBulkDeliveryData = ({ schedule_sms_id, page = 0, pageSize = 30 }) =>
  get(`sms/batch/${schedule_sms_id}/messages?page=${page}&size=${pageSize}`).then((res) => {
    const rows = unwrapPage(res).rows.map((m, i) => ({
      ID: i + 1 + page * pageSize,
      from: m.sender || "",
      to: m.msisdn,
      message: m.message || "",
      created_at: m.deliveredAt || m.sentAt || "",
      status: m.delivered ? "0" : "1",
    }));
    return { data: rows };
  });

// Bulk send. Immediate via /api/sms/bulk; future send time → /api/sms/scheduled.
export const sendBulk = ({ params, contact_list_id }) => {
  const listIds = (Array.isArray(contact_list_id) ? contact_list_id : [contact_list_id])
    .filter((v) => v !== undefined && v !== null && v !== "")
    .map(Number);
  const body = {
    sender: params.short_code,
    message: params.message,
    listIds,
  };
  const when = params.send_date_time ? moment(params.send_date_time) : null;
  if (when && when.isAfter(moment().add(1, "minute"))) {
    return post("sms/scheduled", { ...body, scheduledTime: when.toISOString(), recipientResolution: "LIVE" });
  }
  return post("sms/bulk", body);
};

// Single SMS. POST /api/sms/single { sender, msisdn, message }.
export const sendQuick = (data) =>
  post("sms/single", {
    sender: data.from || data.sender,
    msisdn: data.msisdn,
    message: data.message,
  });
